import { api } from '@/api'

export default {
  async setTankTypes ({ commit }) {
    const response = await api.searchTankTypes()
    let tankTypes = arrangeTankTypesData(response.tankTypes)
    commit('setTankTypes', tankTypes)
  },
  clearTankTypes ({ commit }) {
    commit('setTankTypes', [])
  }
}

const arrangeTankTypesData = tankTypes => {
  return tankTypes.map(t =>
    ({
      id: t.id,
      tankTypeCode: t.tankTypeCode,
      tankName: t.tankName,
      makerName: t.makerName,
      oilMaxVolume: t.oilMaxVolume,
      tankMaxVolume: t.tankMaxVolume,
      oilVolumeRate: t.oilVolumeRate,
      tankWidth: t.tankSize[0],
      tankDepth: t.tankSize[1],
      tankHeight: t.tankSize[2],
      remarks: t.remarks
    })
  )
}
